import React from "react";
import SidebarTop from "./SidebarTop";
import SidebarMain from "./SidebarMain";

const Sidebar2 = ({ isOpen, onExpandSidebar }) => {
  return (
    <div
      className={`
        bg-white 
        shadow-sm
        transition-all 
        duration-300 
        fixed 
        inset-y-0 
        left-0 
        z-40 
        ${isOpen ? "w-72" : "w-20"}
        overflow-y-auto
        border-r-2 border-gray-200
      `}
    >
      {/* Sidebar Top (Logo) */}
      <SidebarTop isOpen={isOpen} />

      {/* Sidebar Main (Navigation Links) */}
      <div className="flex-1">
        <SidebarMain isOpen={isOpen} onExpandSidebar={onExpandSidebar} />
      </div>
    </div>
  );
};

export default Sidebar2;